"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shuffle = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Shuffle = function Shuffle(_a) {
  var id = _a.id;
  var clipPathId = id ? "Shuffle__clip0__".concat(id) : 'Shuffle__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.673 20.007a6.75 6.75 0 01-3.841-1.866L4.615 7.927a4.002 4.002 0 00-2.828-1.173H.667A.667.667 0 010 6.087V4.754c0-.368.299-.667.667-.667h1.12A6.67 6.67 0 016.51 6.034l4.161 4.173 4.162-4.173a6.75 6.75 0 013.841-1.867V1.421a.667.667 0 011.134-.48l4.001 4a.68.68 0 010 .946l-4.001 4a.667.667 0 01-1.134-.466V6.86a4.002 4.002 0 00-1.947 1.066l-4.175 4.16 4.175 4.16c.535.532 1.21.902 1.947 1.067v-2.56a.667.667 0 011.134-.48l4.001 4a.68.68 0 010 .947l-4.001 4a.667.667 0 01-1.134-.467v-2.747zM6.51 18.141l2.52-2.534-1.88-1.88-2.534 2.52a4.002 4.002 0 01-2.828 1.174H.667a.667.667 0 00-.667.666v1.334c0 .368.299.666.667.666h1.12a6.67 6.67 0 004.722-1.946z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Shuffle = Shuffle;